'use client'

import { useEffect } from 'react'

export default function LocatorSetup() {
  useEffect(() => {
    if (process.env.NODE_ENV !== 'development') return

    let cancelled = false

    // Awaited inside an async function rather than chained with .then(), which
    // React Compiler cannot compile.
    const setup = async () => {
      const { default: setupLocatorUI } = await import('@locator/runtime')
      if (cancelled) return
      setupLocatorUI()
    }

    setup()

    return () => {
      cancelled = true
    }
  }, [])

  return null
}
